import Clock from '../../../../assets/icons/clock_icon.svg';

const Timer: React.FC<{minutes: number; seconds: number}> = ({
  minutes,
  seconds,
}) => {
  return (
    <div className="flex flex-col justify-center items-center w-fit">
      <div className="flex flex-col w-full max-w-md">
        <div
          className="flex items-center p-1 rounded-md text-sm w-fit border"
          style={{
            backgroundColor: '#FFF4F6',
            borderColor: '#FDCED8',
          }}>
          <span
            className="mr-2 rounded-[3px] lg:rounded-md p-[2px] lg:p-1 flex items-center text-[12px] lg:text-xs"
            style={{
              backgroundColor: '#DC1F5C',
              color: '#FDCED8',
            }}>
            <img src={Clock} alt="Clock Icon" className="w-4 h-4 mr-1" />
            Timeout:
          </span>
          <span
            style={{color: '#DC1F5C', fontWeight: '600'}}
            className="text-[12px] lg:text-xs">
            {`${minutes} min ${seconds} sec`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Timer;
